import { Button as AntButton } from "antd"
import React from "react"
import { useNavigate } from "react-router-dom"
import styled from "styled-components"

import type { ButtonPropsIF } from "interfaces/ButtonPropsIF"

const AntButtonBase = ({
  children,
  ...props
}: ButtonPropsIF & React.ComponentProps<typeof AntButton>) => {
  return (
    <AntButton type="primary" size={"large"} {...props}>
      {children}
    </AntButton>
  )
}

export const ButtonBase = ({
  children,
  onClick,
  to,
  isLoading = false,
  ...props
}: ButtonPropsIF & React.ComponentProps<typeof AntButton>) => {
  const navigate = useNavigate()
  const isLink = !!to
  const checkIsExternalLink = (url: string) => {
    return url.startsWith("http://") || url.startsWith("https://")
  }
  const isExternalLink = isLink && checkIsExternalLink(to)
  const isInternalLink = isLink && !checkIsExternalLink(to)
  const isInPageLink = isLink && to.startsWith("#")

  if (isExternalLink && isInPageLink) {
    return (
      <AntButtonBase size={"large"} href={to} {...props}>
        {children}
      </AntButtonBase>
    )
  }
  if (isInternalLink) {
    return (
      <AntButtonBase
        onClick={() => {
          navigate(to)
        }}
        {...props}
      >
        {children}
      </AntButtonBase>
    )
  }
  return (
    <AntButtonBase
      loading={isLoading}
      disabled={isLoading}
      onClick={onClick}
      {...props}
    >
      {children}
    </AntButtonBase>
  )
}

export const Button = styled(ButtonBase)`
  border: none;
  color: white;
  background-color: #002766;
`
export const SecondaryButton = styled(ButtonBase)`
  color: white;
  background-color: #ff8311;
  border: none;
  &:hover {
    background-color: #e8b016;
    border: none;
  }
`

export const LinkButton = ({
  children,
  onClick,
  ...props
}: ButtonPropsIF & React.ComponentProps<typeof AntButton>) => {
  return (
    <ButtonBase type="link" onClick={onClick} {...props}>
      {children}
    </ButtonBase>
  )
}
